module.exports = __webpack_public_path__ + "img/Bodice-Front-B9-Da-Eb.69370ce0.png";